import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export const filterUndefined = <T>(
  undefinedCallback?: () => void
): OperatorFunction<T, NonNullable<T>> =>
  // Akita uses null for active state and there's currently a bug where it's sometimes undefined
  filter((val): val is NonNullable<T> => {
    // eslint-disable-next-line no-null/no-null
    if (val === undefined || val === null) {
      if (undefinedCallback) {
        undefinedCallback();
      }

      return false;
    }

    return true;
  });
